/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('ProductCategoryView',["$log","ProductView","ProductCategoryData","ProductData","ProductCategory","ProductCategorySrv","ProductSrv","StyleColor","ItemCategoryView",
        function ($log,ProductView,ProductCategoryData,ProductData,ProductCategory,ProductCategorySrv,ProductSrv,StyleColor,ItemCategoryView)
        {

        var  ProductCategoryView = function (category,catIndex,parentCategoryView,domainView)
        {
            ItemCategoryView.call(this);

            this.catIndex = catIndex;
            this.domainView = domainView;
            this.label = "";
            this.description = "";
            this.productsView = [];
            this.categoriesView = [];
            this.image = null;
            this.companyImage = null;
            this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
            this.styleView = {};  //styleView is an object and category.style is a string
            this.colorPicker = ""; //value liked by the colorpicker
            this.specificImage = null;
            this.isVisibleOnWebSite = true;
            this.parentCategoryView = null;
            this.isSelResKnow = false; // if the selected Ressource know at least one service of the category
            this.selectedProductView=null;
            this.displayType ="array";// only on view loaded by web site theme    //thumbnail //array //selector-array //selector-image
            this.displayProductImages = true;// only on view if children images are different than son

            if (parentCategoryView!==undefined && parentCategoryView!=null)
                this.parentCategoryView=  parentCategoryView;

            this.styleView = this.getStyleFrom(category);
            if (this.styleView)
                this.colorPicker = this.styleView.background;

            if (category!==undefined && category!=null)
            {
                var productView;
                this.loadDataFrom(category);
                for (var i=0;i< category.categories.length;i++)
                    this.categoriesView.push(new ProductCategoryView(category.categories[i],ProductCategoryData.getIndexOf(category.categories[i]),this,domainView));
                for (var j=0;j< category.products.length;j++)
                {
                    productView  = new ProductView(category.products[j],ProductData.getIndexOf(category.products[j]),this,domainView);
                    this.productsView.push(productView);
                    if (this.domainView && this.domainView.addProductViewIndex!==undefined)
                        this.domainView.addProductViewIndex(productView);
                }
            }
        }

        ProductCategoryView.prototype = Object.create(ItemCategoryView.prototype);//inherit functions from ItemCategoryView

        ProductCategoryView.prototype.setImage = function(image)
        {
            for (var j=0;j< this.productsView.length;j++)
                if (this.productsView[j].image==null && !this.productsView[j].specificImage)//if same than previous change
                    this.productsView[j].setImage(image)
            this.image = image;
            this.companyImage = null;
            this.imageDisplayed = this.image;

        }

        ProductCategoryView.prototype.setCompanyImage = function(companyImage)
        {
            for (var j=0;j< this.productsView.length;j++)
                if (this.productsView[j].companyImage==null && !this.productsView[j].specificImage)//if same than previous change
                    this.productsView[j].setImage(companyImage)
            this.image = null;
            this.companyImage = companyImage;
            this.imageDisplayed = this.companyImage;
        }

        ProductCategoryView.prototype.getCategoryView  = function(category)
        {
            var categoryView =null;
            if (this.getModel()===category)
                return this;
            for (var i=0;i< this.categoriesView.length && categoryView==null;i++)
                categoryView = this.categoriesView[i].getCategoryView(category);
            return categoryView;
        }
        ProductCategoryView.prototype.getCategoryViewByLabel  = function(label)
        {
            var categoryView =null;
            if (this.label==label)
                return this;
            for (var i=0;i< this.categoriesView.length && categoryView==null;i++)
                categoryView = this.categoriesView[i].getCategoryViewByLabel(label);
            return categoryView;
        }
        ProductCategoryView.prototype.getProductView  = function(product)
        {
            var productView = null;
            for (var j = 0; j < this.productsView.length; j++)
                if (this.productsView[j].getModel() === product)
                    return this.productsView[j];
            for (var z=0;z< this.categoriesView.length && !productView;z++)
                productView = this.categoriesView[z].getProductView(product);

            return productView;
        };
            ProductCategoryView.prototype.getProductViewById  = function(id)
            {
                var product;
                for (var j = 0; j < this.productsView.length; j++)
                {
                    product = this.productsView[j].getModel();
                    if (product && product.id == id)
                        return this.productsView[j];
                }
                var productView = null;
                for (var z=0;z< this.categoriesView.length&&!productView ;z++)
                    productView = this.categoriesView[z].getProductViewById(id);
                return productView;
            };

            ProductCategoryView.prototype.getCategoryViewById  = function(id)
            {
                var categoryView = null;
                var category = this.getModel();
                if (category && category.id ==id)
                    return this;
                for (var z=0;z< this.categoriesView.length && !categoryView;z++)
                    categoryView = this.categoriesView[z].getCategoryViewById(id);
                return categoryView;
            };

            ProductCategoryView.prototype.getAllProductsView  = function(product)
        {
            var lProductsView = this.productsView.slice(0);

            var array;
            for (var z=0;z< this.categoriesView.length;z++)
            {
                array = this.categoriesView[z].getAllProductsView();
                if (array)
                    for(var j = 0; j < array.length; j++)
                        lProductsView.push(array[j])
            }


            return lProductsView;
        }
        ProductCategoryView.prototype.populateHomeItemsView = function(homeItemsView) {
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].populateHomeItemsView(homeItemsView);
            for (var j=0;j< this.productsView.length;j++)
                if(this.productsView[j].isOnHome)
                    homeItemsView.push({type:'product', item : this.productsView[j],active:false});
        }

        ProductCategoryView.prototype.getProductViewByCodeOrLabel  = function(code)
        {
            var productsView = [];
            for (var j = 0; j < this.productsView.length; j++)
                if (this.productsView[j].code == code || (this.productsView[j].label && this.productsView[j].label.toLowerCase().indexOf(code)!=-1))
                    productsView.push(this.productsView[j]);

            for (var z=0;z< this.categoriesView.length ;z++)
                productsView = productsView.concat(this.categoriesView[z].getProductViewByCodeOrLabel(code));
            return productsView;
        }

            ProductCategoryView.prototype.getProductViewByReference = function(reference)
            {
                var productsView = [];
                for (var j = 0; j < this.productsView.length; j++)
                    if (this.productsView[j].reference == reference)
                        productsView.push(this.productsView[j]);

                for (var z=0;z< this.categoriesView.length ;z++)
                    productsView = productsView.concat(this.categoriesView[z].getProductViewByReference(reference));
                return productsView;
            }

        ProductCategoryView.prototype.copyDataTo = function(category)
        {
            //Assume here than the object in parameter contains only id (must load them)
            category.label = this.label;
            category.description = this.description;
            if (this.parentCategoryView && this.styleView===this.parentCategoryView.styleView)// if is specific set it
                category.style = null;
            else
                category.style = angular.toJson(this.styleView);
            category.image = this.image;
            category.companyImage = this.companyImage;
            category.specificImage = this.specificImage;
            category.isVisibleOnWebSite = this.isVisibleOnWebSite;

        }
        ProductCategoryView.prototype.loadDataFrom = function(category)
        {
            this.label = category.label;
            this.description = category.description;
            this.image = category.image;
            this.companyImage = category.companyImage;
            this.specificImage = category.specificImage;
            if (this.companyImage)
                this.imageDisplayed = this.companyImage;
            else
                this.imageDisplayed = this.image;
            this.isVisibleOnWebSite = category.isVisibleOnWebSite;
        }
        ProductCategoryView.prototype.onStyleViewChange = function()
        {
            var fontColor = StyleColor.getContrastYIQ(this.colorPicker);
            if (!this.styleView || this.styleView.background !=this.colorPicker)
            {
                if (!this.styleView ||//if undefined
                    (this.parentCategoryView && this.parentCategoryView.styleView===this.styleView ))// if same than parent : break inheritance
                    this.styleView = {};
                this.styleView.background  = this.colorPicker;
                this.styleView.color  = fontColor;
                this.updateStyleView();
            }
        }
        ProductCategoryView.prototype.updateStyleView = function(styleView)
        {
            for (var j=0;j< this.categoriesView.length;j++)
                if (this.categoriesView[j].styleView==null)//if same than previous change
                    this.categoriesView[j].updateStyleView(styleView)
        }
        ProductCategoryView.prototype.getStyleFrom = function(category)
        {
            var styleView = null;
            if (category)
                if (category.style && category.style.indexOf('{')!=0) //Previous type before 1.5 was not contains a jsonSTring
                    styleView = null;
                else
                    try {
                        styleView = angular.fromJson(category.style);
                    }
                    catch (ex) {
                        console.log("Error loading style")
                    }
            if (!styleView)
                if (this.parentCategoryView!=null)
                    styleView = this.parentCategoryView.styleView;
            return styleView;
        }
        ProductCategoryView.prototype.isChanged = function()
        {
            var category = this.getModel();
            if (category)
            {
                /*var image = category.image;
                if ((image==null||image=="") &&this.parentCategoryView)
                    image = this.parentCategoryView.image;*/
                var styleView  = this.getStyleFrom(category);
                var styleChanged = (this.styleView && !styleView) ||
                    !this.styleView && styleView ||
                    (this.styleView && styleView &&
                     this.styleView.background != styleView.background);
                return (
                    this.label != category.label ||
                    this.description != category.description ||
                    styleChanged ||
                    this.image != category.image ||
                    this.companyImage !=  category.companyImage
                );

            }
            else
                return true;

        }
        ProductCategoryView.prototype.getModel = function()
        {
            if (this.catIndex!=-1)
                return ProductCategoryData.getByIndex(this.catIndex);
            return null;
        }
        ProductCategoryView.prototype.restoreModel = function()
        {   //undeleted
            var category = this.getModel();
            if (category)
            {
                if (category.parentCategory)
                    category.parentCategory.addCategory(category);
                ProductCategorySrv.restore(category);
            }

        }
        ProductCategoryView.prototype.updateModel = function(endFunction)
        {
            var category = this.getModel();
            if (category==null)
            {
                category = new ProductCategory();
                this.catIndex = ProductCategoryData.getIndexOf(category);
            }

            this.copyDataTo(category);
            if (this.parentCategoryView) {
                var parentCategory = this.parentCategoryView.getModel();
                if (parentCategory && parentCategory !== category.parentCategory) // change of category
                {
                    if (category.parentCategory)
                        category.parentCategory.removeCategory(category);
                    parentCategory.addCategory(category);
                }
            }
            //modify order of categories
            category.categories = [];
            for (var i=0;i<this.categoriesView.length;i++)
                category.addCategory(this.categoriesView[i].getModel());
            category.products = [];
            for (var i=0;i<this.productsView.length;i++)
                category.addProduct(this.productsView[i].getModel());

            ProductCategorySrv.save(category,endFunction, this.checkForRootSaveError);
        };
        ProductCategoryView.prototype.updateModelTree = function()
        {
            var cat = this;
            this.updateModel(function()
            {
                for (var j=0;j< cat.productsView.length;j++)
                    cat.productsView[j].updateModel();
                for (var j=0;j< cat.categoriesView.length;j++)
                    cat.categoriesView[j].updateModelTree();

            })
        };

        ProductCategoryView.prototype.reloadModel = function()
        {
            var category = this.getModel();
            if (category == null)
            {
                this.parentCategoryView.removeCategoryView(this);
            }
            else
            {
                var styleView = this.getStyleFrom(category);
                if (this.styleView && styleView)
                {
                    this.styleView.background = styleView.background;
                    this.styleView.color = styleView.color;
                }
                else
                    this.styleView = styleView;
                if (this.styleView)
                    this.colorPicker = this.styleView.background;

                this.loadDataFrom(category)
            }
        }
        ProductCategoryView.prototype.removeModel = function()
        {
            var category = this.getModel();
            if (category!=null)
            {
                if (category.parentCategory)
                    category.parentCategory.removeCategory(category);
                ProductCategorySrv.remove(category);
            }
        }


        ProductCategoryView.prototype.removeSelections = function()
        {
            //if one product is known by humanResource : category is known
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].removeSelections();
            for (var j=0; j< this.productsView.length; j++)
            {
                this.productsView[j].isSelected = false;
                var product = this.productsView[j].getModel();
                if (product)
                    this.productsView[j].quantity = product.quantity;
            }

        }

        ProductCategoryView.prototype.addCategoryView = function(categoryView)
        {
            var index = this.categoriesView.indexOf(categoryView);
            if (index==-1)
            {
                this.categoriesView.push(categoryView);
                categoryView.parentCategoryView = this;
            }
        }
        
        ProductCategoryView.prototype.removeCategoryView = function(categoryView)
        {
            var index = this.categoriesView.indexOf(categoryView);
            if (index!=-1)
                this.categoriesView.splice(index,1);


        }
        ProductCategoryView.prototype.addProductView = function(productView)
        {
            var index = this.productsView.indexOf(productView);
            if (index==-1)
            {
                this.productsView.push(productView);
                productView.parentCategoryView = this;
            }
        }

        ProductCategoryView.prototype.removeProductView = function(productView)
        {
            var index = this.productsView.indexOf(productView);
            if (index!=-1)
            {
                this.productsView.splice(index,1);
            }


        }

        ProductCategoryView.prototype.changeCategoryPosition = function(scope,categoryView,indexTarget)
        {

            var category = this.getModel();
            var index = this.categoriesView.indexOf(categoryView);
            //Todo check indexTarget!=index
            if (category && indexTarget!=-1 && index!=-1 &&  this.categoriesView && indexTarget<=this.categoriesView.length)
            {
                this.categoriesView.splice(index,1); //remove it
                category.categories.splice(index,1);
                scope.$apply();//TODO CHECK WHY Two APPLYs ARE NEEDED
                if (index<indexTarget)
                    indexTarget--;
                if (indexTarget==this.categoriesView.length)
                {
                    this.categoriesView.push(categoryView);
                    category.categories.push(categoryView.getModel());
                }
                else
                {
                    this.categoriesView.splice(indexTarget,0,categoryView);//insert
                    category.categories.splice(indexTarget,0,categoryView.getModel());
                }
                ProductCategorySrv.save(category, null, this.checkForRootSaveError);
            }
            scope.$apply();


        };
        ProductCategoryView.prototype.changeCategoryPositionView = function(categoryView,indexTarget)
        {
            //Change the category position
            // This : parentCategory
            // categoryView : category to move to indexTarget
            var index = this.categoriesView.indexOf(categoryView);
            if (indexTarget!=-1 && index!=-1 &&  this.categoriesView && indexTarget<=this.categoriesView.length)
            {
                this.categoriesView.splice(index,1); //remove it
                if (indexTarget==this.categoriesView.length)
                    this.categoriesView.push(categoryView);
                else
                    this.categoriesView.splice(indexTarget,0,categoryView);//insert
            }
        };
        ProductCategoryView.prototype.changeProductPositionView = function(productView,indexTarget)
        {
            //Change the product position

            var index = this.productsView.indexOf(productView);
            //Todo check indexTarget!=index
            if (indexTarget!=-1 && index!=-1 &&  this.productsView && indexTarget<=this.productsView.length)
            {
                this.productsView.splice(index,1); //remove it
                if (indexTarget==this.productsView.length)
                    this.productsView.push(productView);
                else
                    this.productsView.splice(indexTarget,0,productView);//insert
            }
        }
        ProductCategoryView.prototype.changeProductPosition = function(scope,productView,indexTarget)
        {

            var category = this.getModel();
            var index = this.productsView.indexOf(productView);
            //Todo check indexTarget!=index
            if (category && indexTarget!=-1 && index!=-1 &&  this.productsView && indexTarget<=this.productsView.length)
            {
                this.productsView.splice(index,1); //remove it
                category.products.splice(index,1);
                scope.$apply();//TODO CHECK WHY TO APPLY ARE NEEDED
                if (index<indexTarget)
                    indexTarget--;
                if (indexTarget==this.productsView.length)
                {
                    this.productsView.push(productView);
                    category.products.push(productView.getModel());
                }
                else
                {
                    this.productsView.splice(indexTarget,0,productView);//insert
                    category.products.splice(indexTarget,0,productView.getModel());
                }
                ProductCategorySrv.save(category, null, this.checkForRootSaveError);
                scope.$apply();

            }

        };
        ProductCategoryView.prototype.moveProduct = function(productView)
        {
            if (productView)
            {
                var product = productView.getModel();
                var category = this.getModel();
                if (product && category)
                {
                    if (productView.parentCategoryView)
                    {
                        var index = productView.parentCategoryView.productsView.indexOf(productView);
                        if (index!=-1)
                        {
                            productView.parentCategoryView.productsView.splice(index,1);
                            product.parentCategory.products.splice(index,1);

                        }
                    }
                    this.addProductView(productView);
                    category.addProduct(product)
                    ProductSrv.save(product);
                }
            }
        };
        ProductCategoryView.prototype.moveCategory = function(categoryView)
        {
            if (categoryView)
            {
                var categoryToMove = categoryView.getModel();
                var category = this.getModel();
                if (categoryToMove && category)
                {
                    if (categoryView.parentCategoryView)
                    {
                        var index = categoryView.parentCategoryView.categoriesView.indexOf(categoryView);
                        if (index!=-1)
                        {
                            categoryView.parentCategoryView.categoriesView.splice(index,1);
                            categoryToMove.parentCategory.categories.splice(index,1);
                        }

                    }
                    this.addCategoryView(categoryView)
                    category.addCategory(categoryToMove)
                    ProductCategorySrv.save(categoryToMove, null, this.checkForRootSaveError);
                }
            }
        };
        ProductCategoryView.prototype.canSave = function()
        {
            return (this.label && this.label!="" );
        };
        ProductCategoryView.prototype.initWebDisplay = function(forceTo)
        {
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].initWebDisplay(forceTo);

            this.displayProductImages = false;
            for (var j=0;j< this.productsView.length && !this.displayProductImages;j++)
                if (this.productsView[j].imageDisplayed!==this.imageDisplayed)
                    this.displayProductImages = true;
            for (var j=0;j< this.categoriesView.length && !this.displayServiceImages;j++)
                if (this.categoriesView[j].imageDisplayed!==this.imageDisplayed)
                    this.displayProductImages = true;

            if (forceTo!==undefined && forceTo!="")
                this.displayType=forceTo;
            else
                if (this.displayProductImages)
                    this.displayType="thumbnail";
                else
                    this.displayType="array";
        };
        ProductCategoryView.prototype.populateDisplayTypeResource = function(array)
        {
            var defaultDType =  this.displayProductImages ? "thumbnail" : "array";
            if (this.displayType!=defaultDType)
            {
                var cat = this.getModel();
                if (cat)
                    array.push({id:cat.id,type:this.displayType});
            }
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].populateDisplayTypeResource(array);
        };

        return ProductCategoryView;
}]);



// WEBPACK FOOTER //
// ./js/services/views/ProductCategoryView.js